export default "__VITE_ASSET__Dtsg3Iqw__"